import RatingPage from '@components/RatingPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'running_difficulty'

// Map numeric ratings to meaningful text values
const RATING_VALUES = {
  '1': 'Very Easy',
  '2': 'Easy',
  '3': 'Moderate',
  '4': 'Hard',
  '5': 'Very Hard',
}

export default function RunningDifficultyPage() {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(RATING_VALUES).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the rating value from the form
    const formData = new FormData(event.currentTarget)
    const rating = formData.get('rating') as string

    if (!rating) return

    // Get the corresponding text value
    const textValue = RATING_VALUES[rating as keyof typeof RATING_VALUES]

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How hard would it be for you to run 1 km (0.6 miles)?',
      answer_key: rating,
      answer: textValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <RatingPage
      title="pages.onboarding.runningDifficulty.heading"
      minSubtitle="pages.onboarding.runningDifficulty.easy"
      maxSubtitle="pages.onboarding.runningDifficulty.veryHard"
      onSubmit={handleSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
